/*
 * @Author: your name
 * @Date: 2020-08-08 18:50:07
 * @LastEditTime: 2020-08-10 14:23:44
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/vender/x-lib-ui-h5.js
 */
import Vue from 'vue'
import XLibUiH5, { XRequestPlugin, XEventbusPlugin, XStoragePlugin, XLodashPlugin, XEventOutsideDirective } from '@/lib/ui'
import i18n from '@/locale/index'
import router from '@/router'
import EventbusMixin from '../mixin/eventbus.mixin'
import FormBuildEngine from '@/lib/ui/components/form/form-build-engine'
import './form-schema-config/index'

Vue.use(XLodashPlugin, {
  name: 'lodash'
})

Vue.use(XStoragePlugin, {
  namespace: '__xdap__'
})

Vue.use(XEventbusPlugin, {
  name: 'bus',
  type: 'CUSTOM'
})

Vue.use(XEventOutsideDirective)

Vue.mixin(EventbusMixin)

Vue.use(FormBuildEngine)

console.log(process.env)
Vue.use(XRequestPlugin, {
  baseURL: process.env.VUE_APP_BASE_DOMAIN,
  headers: {
    'Accept-Language': 'zh-CN',
    xdapversion: process.env.VUE_APP_XDAP_VERSION
  },
  needShowMessage: true,
  businessErrorCatch: function (
    failRes,
    response,
    needShowMessage
  ) {
    // 通用业务错误处理
    // console.log(failRes, response, needShowMessage)

    if (failRes.code === 'error' && needShowMessage) {
      Vue.prototype.$message({
        message: failRes.message,
        type: 'error'
      })
    }

    if (failRes.bizCode === '3027' || failRes.bizCode === '3031' || failRes.bizCode === '3032' || failRes.bizCode === '3049') {
      router.replace({ name: '423', query: { publicFormStatus: true } })
    }
  },
  errorCatch: function (err, needShowMessage) {
    // console.error(err)
    // return false 的情况下，不会执行系统默认逻辑
    if (!err.response) {
      return true
    }
    if (err.response && err.response.status === 401) {
      // Vue.prototype.$message.error()
      router.replace({ name: 'login' })
      return true
    } else if (err.response.status === 404) {
      // TODO: 提示
    } else if (err.response.status === 423) {
      router.replace({ name: '423' })
      return true
    } else if (err.response.status === 416) {
      router.replace({ name: '416' })
      return true
    } else if (err.response.status === 417) {
      router.replace({ name: '417' })
      return true
    } else if (err.response.status === 424) {
      router.replace({ name: '424' })
      return true
    } else if (err.response.status === 500 && needShowMessage) {
      Vue.prototype.$message({
        message: i18n._t('common.networkErrorText', i18n.locale, i18n.messages),
        type: 'error'
      })
      return true
    } else if (err.response.status === 402) {
      // 版本过期
      // Vue.prototype.$messageBox({
      //   title: i18n._t('common.versionOverdueTitle', i18n.locale, i18n.messages),
      //   customClass: 'version-overdue-box',
      //   messageComponent: 'version-overdue'
      // })
      Vue.prototype.$loading.hide()
      Vue.prototype.$showVersionOverdue()
      return true
    } else if (err.response.status === 410) { // 版本更新
      Vue.prototype.$loading.hide()
      Vue.prototype.$funcUpdate.openModal()
    } else {
      return true
    }
  }
})

Vue.use(XLibUiH5)
